import { render, staticRenderFns } from "./IncomeInvoice.vue?vue&type=template&id=29134f23&scoped=true"
import script from "./IncomeInvoice.vue?vue&type=script&lang=js"
export * from "./IncomeInvoice.vue?vue&type=script&lang=js"
import style0 from "./IncomeInvoice.vue?vue&type=style&index=0&id=29134f23&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29134f23",
  null
  
)

export default component.exports